import React, { useState, useContext, useEffect } from 'react';
import { Row } from 'react-styled-flexboxgrid';
import { analytics } from '../../../helpers/firebaseHelper';
import { Col, Header } from './style';
import { SearchContext, initialState } from '../../../contexts/SearchContext';
import { slugify, createUrl, cleanParams } from '../../../helpers/urlHandler';
import Text from 'reusecore/src/elements/Text';
import Input from '../../../components/Input';
import ListCategories from '../../../models/local/categories/ListCategories';
import inputSelectStyles from '../../AddPost/Styles/InputSelectStyles';
import Select, { components } from 'react-select';
import ListTowns from '../../../models/local/towns';
import SubCategories from '../../../models/local/categories/SubCategories';
import ListMakes from '../../../models/local/cars/Make';
import Icon from 'react-icons-kit';
import { undo } from 'react-icons-kit/fa/undo';
import Canonical from '../../../components/PageMeta/Canonical';
import { isMobile, isFirefox } from 'react-device-detect';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';

const MAX_PRICE = 999999999; // 999 999 999

let _mounted = false;

let timeout;

const FilterElements = props => {
  const { t } = useTranslation();
  const { state, dispatch } = useContext(SearchContext);
  const router = useRouter();
  const { query } = router;

  const [filterState, setFilterState] = useState(state);

  const { category, priceMin, priceMax, text, town, subInfos } = filterState;

  const [textInput, setTextInput] = useState(text);

  const _listCategoriesArray = ListCategories(t);
  const subcategories = SubCategories(t);
  const _listTownsArray = ListTowns;

  if (_listCategoriesArray[0].id !== t('search.sidebar.all')) {
    _listCategoriesArray.unshift({
      options: [
        { value: t('search.sidebar.all'), label: t('search.sidebar.all') },
      ],
      id: t('search.sidebar.all'),
      label: `--- ${t('search.sidebar.all')} ---`,
    });
  }

  if (_listTownsArray[0].id !== t('search.sidebar.all')) {
    _listTownsArray.unshift({
      options: [
        { value: t('search.sidebar.all'), label: t('search.sidebar.all') },
      ],
      id: t('search.sidebar.all'),
      label: `--- ${t('search.sidebar.all')} ---`,
    });
  }

  const onTextChange = event => {
    const {
      target: { value },
    } = event;

    setTextInput(value);

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      pushSearch({
        ...filterState,
        text: value,
      });
    }, 300);
  };

  const pushSearch = search => {
    const { category } = search;

    const as = category
      ? `/${SEARCH_PAGE}/${slugify(category)}`
      : `/${SEARCH_PAGE}/all`;

    const url = as + createUrl(cleanParams(search));
    router.push(url, url, { shallow: true });
  };

  const handleApply = () => {
    dispatch({
      type: 'UPDATE',
      payload: filterState,
    });
  };

  const handleClearSearch = async () => {
    pushSearch({ ...initialState });
  };

  const groupStyles = {
    color: 'white',
    background: '#00BCD4',
    padding: '5px 0px',
    display: 'flex',
    textAlign: 'center',
  };

  const GroupHeading = props => (
    <div style={groupStyles}>
      <components.GroupHeading {...props} />
    </div>
  );

  const navigateToCategory = category => {
    pushSearch({ ...filterState, subInfos: {}, category });
  };

  const _categoryDynamical = () => {
    if (!category) return;
    const catName = t('category.slug.' + category);
    return (
      <Select
        aria-label={t('search.sidebar.categories')}
        instanceId="selectCategoryDyn"
        placeholder={t('search.sidebar.categories')}
        noOptionsMessage={() => t('search.sidebar.empty')}
        value={[{ value: catName, label: t('category.' + catName) }]}
        options={_listCategoriesArray}
        components={{ GroupHeading }}
        onChange={selected => {
          let val =
            selected.value === t('search.sidebar.all') ? '' : selected.value;
          if (selected.value !== catName) {
            navigateToCategory(val);
          }
        }}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: '#dcf5f9',
            primary: '#dcf5f9',
          },
        })}
        styles={inputSelectStyles}
      />
    );
  };

  const _townDynamical = () => {
    if (!town) return;
    return (
      <Select
        aria-label={t('search.sidebar.categories')}
        instanceId="selectLocationDyn"
        placeholder={t('search.sidebar.location')}
        noOptionsMessage={() => t('search.sidebar.empty')}
        components={{ GroupHeading }}
        value={[{ value: '' + town + '', label: '' + town + '' }]}
        options={_listTownsArray}
        onChange={selected => {
          let val =
            selected.value === t('search.sidebar.all') ? '' : selected.value;
          pushSearch({
            ...filterState,
            town: val,
          });
        }}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: '#dcf5f9',
            primary: '#dcf5f9',
          },
        })}
        styles={inputSelectStyles}
      />
    );
  };

  const _townDefault = () => {
    if (town) return;
    return (
      <Select
        aria-label={t('search.sidebar.location')}
        instanceId="selectLocation"
        placeholder={t('search.sidebar.location')}
        noOptionsMessage={() => t('search.sidebar.empty')}
        components={{ GroupHeading }}
        value={[]}
        options={_listTownsArray}
        onChange={selected => {
          let val =
            selected.value === t('search.sidebar.all') ? '' : selected.value;
          pushSearch({
            ...filterState,
            town: val,
          });
        }}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: '#dcf5f9',
            primary: '#dcf5f9',
          },
        })}
        styles={inputSelectStyles}
      />
    );
  };

  const _categoryDefault = () => {
    if (category) return;

    return (
      <Select
        aria-label={t('search.sidebar.categories')}
        instanceId="selectCategories"
        placeholder={t('search.sidebar.categories')}
        noOptionsMessage={() => t('search.sidebar.empty')}
        value={[]}
        options={_listCategoriesArray}
        components={{ GroupHeading }}
        onChange={selected => {
          let val =
            selected.value === t('search.sidebar.all') ? '' : selected.value;
          if (selected.value !== category) {
            navigateToCategory(val);
          }
        }}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: '#dcf5f9',
            primary: '#dcf5f9',
          },
        })}
        styles={inputSelectStyles}
      />
    );
  };

  const _componentDynamical = () => {
    const catName = t('category.slug.' + category);
    if (!category || !subcategories[catName]) return;
    let arrayComponent = [];
    let _subInfos = {};
    if (typeof subInfos === 'string') {
      let _valueArray = subInfos.split(',');
      _valueArray.map(val => {
        if (val) {
          let _subvalArray = val.split('|');
          _subInfos[_subvalArray[0]] = _subvalArray[1];
        }
      });
    }
    subcategories[catName].map((component, i) => {
      switch (component.id) {
        case 'InputBrandCarsComponent':
          arrayComponent.push(
            <div key={i} style={{ marginBottom: '3rem' }}>
              <Select
                aria-label={t('search.sidebar.brand')}
                instanceId={'selectBrand_' + component.id}
                placeholder={t('search.sidebar.brand')}
                noOptionsMessage={() => t('search.sidebar.empty')}
                defaultValue={
                  _subInfos[component.name]
                    ? {
                        value: _subInfos[component.name],
                        label: _subInfos[component.name],
                      }
                    : []
                }
                value={
                  _subInfos[component.name]
                    ? {
                        value: _subInfos[component.name],
                        label: _subInfos[component.name],
                      }
                    : []
                }
                options={ListMakes}
                onChange={selected => {
                  let val =
                    selected.label === t('search.sidebar.all')
                      ? ''
                      : selected.label;
                  pushSearch({
                    ...filterState,
                    subInfos: {
                      ..._subInfos,
                      [component.name]: val,
                    },
                  });
                }}
                theme={theme => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary25: '#dcf5f9',
                    primary: '#dcf5f9',
                  },
                })}
                styles={inputSelectStyles}
              />
            </div>
          );
          break;
        case 'InputField':
          if (component.type === 'number') {
            arrayComponent.push(
              <Row key={i}>
                <Col md={6} sm={6} xs={6}>
                  {/* Switch component */}
                  <Input
                    elementType="input"
                    value={
                      _subInfos[component.name + 'Min']
                        ? _subInfos[component.name + 'Min']
                        : ''
                    }
                    style={{
                      marginBottom: '3rem',
                      width: '100%',
                    }}
                    label={component.placeHolder + ' min.'}
                    elementConfig={{
                      type: 'number',
                      required: 'required',
                      min: 0,
                      max: MAX_PRICE,
                    }}
                    changed={e => {
                      let {
                        target: { value },
                      } = e;
                      if (value > MAX_PRICE) {
                        value = MAX_PRICE;
                      }
                      pushSearch({
                        ...filterState,
                        subInfos: {
                          ..._subInfos,
                          [component.name + 'Min']: value,
                        },
                      });
                    }}
                  />
                </Col>
                <Col md={6} sm={6} xs={6}>
                  {/* Switch component */}
                  <Input
                    elementType="input"
                    value={
                      _subInfos[component.name + 'Max']
                        ? _subInfos[component.name + 'Max']
                        : ''
                    }
                    style={{
                      marginBottom: '3rem',
                      width: '100%',
                    }}
                    label={component.placeHolder + ' max.'}
                    elementConfig={{
                      type: 'number',
                      required: 'required',
                      min: 0,
                      max: MAX_PRICE,
                    }}
                    changed={e => {
                      let {
                        target: { value },
                      } = e;
                      if (value > MAX_PRICE) {
                        value = MAX_PRICE;
                      }
                      pushSearch({
                        ...filterState,
                        subInfos: {
                          ..._subInfos,
                          [component.name + 'Max']: value,
                        },
                      });
                    }}
                  />
                </Col>
              </Row>
            );
          } else {
            arrayComponent.push(
              <div key={i} style={{ marginBottom: '3rem' }}>
                <Input
                  elementType="input"
                  value={
                    _subInfos[component.name] ? _subInfos[component.name] : ''
                  }
                  elementConfig={{
                    type: component.type,
                    required: 'optionnal',
                  }}
                  style={{
                    marginBottom: '3rem',
                  }}
                  label={component.placeHolder}
                  changed={selected => {
                    pushSearch({
                      ...filterState,
                      subInfos: {
                        ..._subInfos,
                        [component.name]: selected.target.value,
                      },
                    });
                  }}
                />
              </div>
            );
          }
          break;
        case 'InputSelected':
          arrayComponent.push(
            <div key={i} style={{ marginBottom: '3rem' }}>
              <Select
                aria-label={component.placeHolder}
                instanceId={'selectInput_' + component.id}
                placeholder={component.placeHolder}
                noOptionsMessage={() => t('search.sidebar.empty')}
                defaultValue={
                  _subInfos[component.name]
                    ? {
                        value: _subInfos[component.name],
                        label: component.needTranslate
                          ? t('subCategory.' + _subInfos[component.name])
                          : _subInfos[component.name],
                      }
                    : []
                }
                value={
                  _subInfos[component.name]
                    ? {
                        value: _subInfos[component.name],
                        label: component.needTranslate
                          ? t('subCategory.' + _subInfos[component.name])
                          : _subInfos[component.name],
                      }
                    : []
                }
                options={component.data}
                onChange={selected => {
                  pushSearch({
                    ...filterState,
                    subInfos: {
                      ..._subInfos,
                      [component.name]: selected.value,
                    },
                  });
                }}
                theme={theme => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary25: '#dcf5f9',
                    primary: '#dcf5f9',
                  },
                })}
                styles={inputSelectStyles}
              />
            </div>
          );
          break;
      }
    });
    return arrayComponent;
  };

  useEffect(() => {
    if (_mounted) {
      handleApply();
    }
  }, [filterState]);

  useEffect(() => {
    let search = { ...initialState, ...query };
    if (_mounted) {
      const { category, text } = search;

      if (category === 'all') {
        search = { ...search, category: '' };
      }

      setFilterState(search);
      setTextInput(text);
    }

    if (typeof window !== 'undefined' && analytics) {
      analytics.logEvent('search_complex', {
        category: search.category,
        price_max: search.priceMax,
        price_min: search.priceMin,
        title: search.text,
        town: search.town,
      });
    }
  }, [query]);

  useEffect(() => {
    _mounted = true;
    const search = location.search.substring(1);
    const qs =
      search.length > 0
        ? JSON.parse(
            '{"' +
              decodeURI(search)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
              '"}'
          )
        : {};
    if (
      qs.hasOwnProperty('from') &&
      qs.from === 'alerts' &&
      isMobile &&
      !isFirefox
    ) {
      window.location.href = process.env.DEEP_LINK + '/filters?' + search;
    }

    return () => {
      _mounted = false;
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  return (
    <div
      style={{
        backgroundColor: 'white',
        padding: '40px 12px',
        fontFamily: 'Poppins',
      }}
    >
      <Canonical category={slugify(category)} />
      <Header>
        <Text fontSize={20} content={t('search.sidebar.title')} />
        <Icon onClick={handleClearSearch} icon={undo} size={18} />
      </Header>
      <Input
        elementType="input"
        value={textInput}
        label={t('search.sidebar.keyword')}
        elementConfig={{
          type: 'text',
          required: 'required',
        }}
        style={{
          marginBottom: '3rem',
        }}
        changed={onTextChange}
      />
      <Row>
        <Col md={6} sm={6} xs={6}>
          <Input
            elementType="input"
            value={priceMin}
            label={t('search.sidebar.price.min')}
            elementConfig={{
              type: 'number',
              required: 'required',
              min: 0,
              max: MAX_PRICE,
            }}
            style={{
              marginBottom: '3rem',
              width: '100%',
            }}
            changed={e => {
              let {
                target: { value },
              } = e;
              if (value > MAX_PRICE) {
                value = MAX_PRICE;
              }
              pushSearch({
                ...filterState,
                priceMin: value,
              });
            }}
          />
        </Col>
        <Col md={6} sm={6} xs={6}>
          <Input
            elementType="input"
            value={priceMax}
            label={t('search.sidebar.price.max')}
            elementConfig={{
              type: 'number',
              required: 'required',
              min: 0,
              max: MAX_PRICE,
            }}
            style={{
              marginBottom: '3rem',
              width: '100%',
            }}
            changed={e => {
              let {
                target: { value },
              } = e;
              if (value > MAX_PRICE) {
                value = MAX_PRICE;
              }
              pushSearch({
                ...filterState,
                priceMax: value,
              });
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '3rem' }}>
        <Col md={12} sm={12} xs={12}>
          {_categoryDynamical()}
        </Col>
        <Col md={12} sm={12} xs={12}>
          {_categoryDefault()}
        </Col>
      </Row>
      <Row>
        <Col md={12} sm={12} xs={12}>
          {_componentDynamical()}
        </Col>
      </Row>
      <Row>
        <Col md={12} sm={12} xs={12}>
          {_townDynamical()}
        </Col>
        <Col md={12} sm={12} xs={12}>
          {_townDefault()}
        </Col>
      </Row>
      {/*<Row style={{ marginBottom: 20 }}>*/}
      {/*  <Col mdOffset={6} md={6} xs={12} sm={12}>*/}
      {/*    <Row>*/}
      {/*      <Col xs>*/}
      {/*        /!* <Button*/}
      {/*          onClick={handleApply}*/}
      {/*          title="Filtrer"*/}
      {/*          style={{ marginTop: 30, width: '100%' }}*/}
      {/*        />*!/*/}
      {/*      </Col>*/}
      {/*    </Row>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
    </div>
  );
};

export default FilterElements;
